import { render } from "./dayone.vue?vue&type=template&id=2d0d9815"
import script from "./dayone.vue?vue&type=script&lang=js"
export * from "./dayone.vue?vue&type=script&lang=js"

import "./dayone.vue?vue&type=style&index=0&id=2d0d9815&lang=scss"
script.render = render

export default script